import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "modal__title" };
const _hoisted_2 = ["href"];
const _hoisted_3 = ["href"];
import { ref } from 'vue';
import authenticationChecker, { EVENT_AUTH_EXPIRED } from '../services/AuthenticationChecker';
import env from '../services/AppEnv';
import events from '../services/EventBus';
import Icon from "./Icon.vue";
import Modal from './Modal.vue';
import { useRouter } from "vue-router";
export default /*@__PURE__*/ _defineComponent({
    __name: 'AuthenticationExpired',
    setup(__props) {
        const router = useRouter();
        const authExpired = ref(false);
        // we trust that the application reloads after login
        if (env.user.authenticated) {
            authenticationChecker.init();
            events.$on(EVENT_AUTH_EXPIRED, () => authExpired.value = true);
        }
        function path(route) {
            try {
                return router.resolve({ name: route }).href;
            }
            catch (error) {
                return window.location.href; // clicking on the current URL will most likely trigger a redirect to a login page
            }
        }
        return (_ctx, _cache) => {
            return (authExpired.value)
                ? (_openBlock(), _createBlock(Modal, {
                    key: 0,
                    classes: ['modal--small'],
                    unclosable: true
                }, {
                    header: _withCtx(() => [
                        _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t('login.expired.title')), 1)
                    ]),
                    content: _withCtx(() => [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t('login.expired.text')), 1),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        _createElementVNode("a", {
                            href: path('login'),
                            class: "button button--primary"
                        }, [
                            _createVNode(Icon, { name: "login" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('login.log-in')), 1)
                        ], 8, _hoisted_2),
                        _cache[1] || (_cache[1] = _createTextVNode()),
                        _createElementVNode("a", {
                            href: path('home'),
                            class: "button button--outline"
                        }, [
                            _createVNode(Icon, { name: "home" }),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t('nav.home')), 1)
                        ], 8, _hoisted_3)
                    ]),
                    _: 1
                }))
                : _createCommentVNode("", true);
        };
    }
});
